import $ from 'jquery';
import * as L from 'leaflet';

let EmbeddedMap = {
    $el: null,
    map: null,
    myIcon: null,
    latitude: null,
    longitude: null
};
EmbeddedMap.attach = function ($embeddedMap) {
    this.$el = $embeddedMap;
    this.map = new L.Map('distMapView');
    this.myIcon = new L.divIcon('distMapView');

    $.fn.reverse = function() {
        return this.pushStack(this.get().reverse(), arguments);
    };

    let mapMarker = function (lat, lng, no) {
        this.myIcon = L.divIcon({
            className: 'rollex-map-marker',
            iconSize: [37, 37],
            html: no
        });
        L.marker([lat, lng], {icon: this.myIcon}).addTo(this.map)
            .openPopup();
    }.bind(this);


    let updateDistMap = function (data) {
        let lt, lg, no;
        this.map.setView([data.lat, data.lng], 14.5);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        lt = data.lat;
        lg = data.lng;
        no = data.number;
        mapMarker(lt, lg, no);
    }.bind(this);

    function initlayerGroupMap() {
        return updateDistMap({
            lat: window.distributor.lat,
            lng: window.distributor.lng,
            number: 1
        });
    }

    initlayerGroupMap();
};

export default EmbeddedMap;
